import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { injectIntl } from 'react-intl';
import { Table, TBody, TR, TD } from 'oy-vey';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Body from '../modules/Body';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import CurrencyView from '../modules/CurrencyView';

import { url, sitename } from '../../../config';

class BookingRequestHost extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      reservationId: PropTypes.number.isRequired,
      confirmationCode: PropTypes.number.isRequired,
      hostName: PropTypes.string.isRequired,
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      checkOut: PropTypes.string.isRequired,
      listTitle: PropTypes.string.isRequired,
      basePrice: PropTypes.number.isRequired,
      total: PropTypes.number.isRequired,
      currency: PropTypes.string.isRequired,
      hostServiceFee: PropTypes.number.isRequired,
    }).isRequired

  };

  render() {
    const textStyle = {
      color: '#404040',
      backgroundColor: '#F7F7F7',
      fontFamily: 'Arial',
      fontSize: '16px',
      padding: '35px',
    };

    const btnCenter = {
      textAlign: 'center'
    }

    const buttonStyle = {
      margin: 0,
      fontFamily: 'Arial',
      padding: '10px 16px',
      textDecoration: 'none',
      borderRadius: '2px',
      border: '1px solid',
      textAlign: 'center',
      verticalAlign: 'middle',
      fontWeight: 'bold',
      fontSize: '18px',
      whiteSpace: 'nowrap',
      background: '#ffffff',
      borderColor: '#0667B3',
      backgroundColor: '#0667B3',
      color: '#ffffff',
      borderTopWidth: '1px',

    }

    moment.locale("de-DE")
    
    const { content: { reservationId, confirmationCode, hostName, guestName, checkIn, checkOut, threadId, logo } } = this.props;
    const { content: { listTitle, basePrice, total, hostServiceFee, currency } } = this.props;

    let checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '';
    let checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : '';
    // let actionURL = url + '/rentals/current';
    let actionURL = url + '/message/' + threadId + '/host';
    let subtotal = total - hostServiceFee;
    return (
      <Layout>
        <Header color="#0667B3" backgroundColor="#F7F7F7" logo={logo} />
        <div>
          <Table width="100%" >
            <TBody>
              <TR>
                <TD style={textStyle}>
                  <EmptySpace height={20} />
                  <div>
                    Hallo {hostName},
                    </div>
                  <EmptySpace height={20} />
                  <div>
                    Herzlichen Glückwunsch! Sie haben eine neue Reservierung ({confirmationCode}) von {guestName} vorliegen.
                  </div>
                  <EmptySpace height={10} />
                  <div>
                    {guestName} möchte die Fläche {listTitle} von {checkInDate} bis {checkOutDate} buchen.
                    </div>
                  <EmptySpace height={10} />
                  <div>
                    Basierend auf dem Flächenpreis inklusive aller Nebenkosten in Höhe von <CurrencyView amount={basePrice} currency={currency} />
                    {' '} pro Tag, liegt Ihre voraussichtliche Gesamtauszahlung bei <CurrencyView amount={subtotal} currency={currency} />.
                  </div>
                  <EmptySpace height={40} />
                  <div style={btnCenter}>
                    <a href={actionURL} style={buttonStyle}>Annehmen oder Ablehnen</a>
                  </div>
                  <EmptySpace height={40} />
                  <div>
                    Vielen Dank, <br />
                    Ihr {sitename} Team
                    </div>
                </TD>
              </TR>
            </TBody>
          </Table>
          <EmptySpace height={40} />
        </div>
        <Footer />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default injectIntl(BookingRequestHost);
